<template>

    <div id="booking-flow-1">
        
        <router-view />
        
    </div>

</template>

<script>

    import router from '../router.js'
    import filteredResources from '../components/booking/FilteredResources.vue'
    import bookingCreateForm from '../components/booking/BookingCreateForm.vue'
    import notify from '../utils/notify/Notify.js'

    export default {

        components: {
            filteredResources,
            bookingCreateForm
        },
        data: function() {
            return {
                
            }
        },
        computed: {
            resource: function() {
                return this.$store.getters.getResource
            },
            startdatetime: function() {
                return this.$store.getters.getStartDateTime
            },
            duration: function() {
                return this.$store.getters.getDuration
            },
            is_auth: function() {
                return this.$store.getters.isAuthenticated
            }
        },
        watch: {
            resource: function() {
                router.push('/search/bookingform')
            },
            startdatetime: function() {
                router.push('/search/bookingform')
            },
            duration: function() {
                router.push('/search/bookingform')
            }
        },
        beforeRouteLeave (to, from, next) {
            this.$store.commit('clearState')
            next()
        }

    }

</script>